import React from 'react';

export default function OpenEnrollment() {
  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <iframe
        style={{
          width: '95%',
          height: '100vh',
          marginLeft: 40,
          overflow: 'hidden',
          border: 'none'
        }}
        src='https://flimp.live/FEG-2025-OE-DP-EM?em=Y'
      />
    </div>
  );
}
